<template>
    <div class="content">
        <div class="content-bgc">
            <img class="content-img" :src="bigImgInfo.contactUs" alt="centered image" />
            <div class="content-txt">
                <div class="content-e">Contact us</div>
                <div class="content-c">联系我们</div>
            </div>
        </div>
        <div class="address-page">
            <div class="address-view">
                <div class="address-img">
                    <div class="title">留下您的<div style="color: #B18148;">合作需求</div>
                    </div>
                    <div class="phone">招商热线</div>
                    <div class="phone-num">{{ contactUsInfo.mobile }}</div>
                    <div class="line"></div>
                    <div class="phone">招商中心</div>
                    <div class="phone-num" style="font-size: 24px;">{{ contactUsInfo.address }}</div>
                    <div class="line"></div>
                </div>
                <div class="line"></div>
                <img class="address-img1" :src="contactUsInfo.singleImage" alt="" />
            </div>
        </div>
        <div class="form-page">
            <img class="form-img" src="../assets/images3/2.png" alt="">
            <div class="form-view">
                <div class="form-left">
                    <div class="title">您也可以给我们<div style="color: #B18148;">留言</div>
                    </div>
                    <div class="form-mark">生态圈运营实力，助力企业成长</div>
                </div>
                <div class="form-right">
                    <div class="input-view">
                        <div class="input-style" style="margin-top: 32px;">
                            <el-input v-model="name" placeholder="联系人"></el-input>
                        </div>
                        <div class="input-style" style="margin-top: 12px;">
                            <el-input v-model="phone" placeholder="联系方式"></el-input>
                        </div>
                    </div>
                    <div class="textarea-view">
                        <el-input type="textarea" :rows="5" placeholder="请简单描述您的需求" v-model="demand" resize="none">
                        </el-input>
                    </div>
                    <div class="submit" @click="setLeaveMessageSubmitApi">提交留言</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import bigImgMixin from "../mixins/bigImgMixin.js";

export default {
    mixins: [bigImgMixin],
    components: {
    },
    data() {
        return {
            name: '',
            phone: '',
            demand: '',
            contactUsInfo: {}
        };
    },
    created() {
    },
    mounted() {
        this.getContactUsApi();
    },
    methods: {
        // 联系我们  
        async getContactUsApi() {
            try {
                const res = await this.$get('/api/other/contactUs');
                this.contactUsInfo = res.data;
                console.warn(res, "联系我们")
            } catch (error) {
                console.error('Error fetching basic config:', error);
            }
        },
        // 提交留言
        async setLeaveMessageSubmitApi() {
            try {
                const res = await this.$post('/api/other/leaveMessageSubmit', {
                    name: this.name,
                    mobile: this.phone,
                    needContent: this.demand
                });
                if (res.code == 0) {
                    this.$message({
                        message: res.msg,
                        type: 'warning'
                    });
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });

                    this.name = "";
                    this.phone = "";
                    this.demand = "";
                }
            } catch (error) {
                this.$message({
                    message: error.msg,
                    type: 'error'
                });
                console.error('Error fetching basic config:', error);
            }
        },
    },
};  
</script>

<style lang="scss" scoped>
.content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    .content-bgc {
        width: 100%;
        height: 350px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;

        .content-img {
            height: 100%;
            width: 100%;
        }

        .content-txt {
            display: inline-block;
            /* 防止内容撑破容器 */
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            /* 相对于自身宽高的50%进行移动，实现居中 */
            width: 90%;

            .content-e {
                font-size: 14px;
                font-family: Montserrat, Montserrat-700;
                font-weight: 700;
                text-align: LEFT;
                color: #ffffff;
            }

            .content-c {
                margin-top: 10px;
                font-size: 28px;
                font-family: Microsoft YaHei, Microsoft YaHei-700;
                font-weight: 700;
                text-align: LEFT;
                color: #ffffff;
            }
        }
    }

    .form-page {
        margin-top: 120px;
        width: 100%;
        // height: 484px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        .form-img {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            z-index: -1;
        }

        .form-view {
            // display: flex;
            // justify-content: space-between;
            // align-items: center;
            width: 90%;
            height: 100%;
            // background: pink;

            .form-left {
                // width: 50%;
                // height: 284px;

                .title {
                    margin-top: 60px;
                    font-size: 28px;
                    font-family: Microsoft YaHei, Microsoft YaHei-700;
                    font-weight: 700;
                    color: #222222;
                    display: flex;
                    align-items: center;
                }

                .form-mark {
                    margin-top: 16px;
                    font-size: 14px;
                    font-family: Microsoft YaHei, Microsoft YaHei-700;
                    font-weight: 700;
                    color: #999999;
                }
            }

            .form-right {
                // width: 50%;
                // height: 284px;

                .input-view {
                    width: 100%;
                    // display: flex;
                    // justify-content: space-between;

                    .input-style {
                        width: 100%;
                    }
                }

                .textarea-view {
                    margin-top: 12px;
                }

                .submit {
                    cursor: pointer;
                    margin-top: 24px;
                    margin-bottom: 120px;
                    width: 100%;
                    height: 56px;
                    background: #b18148;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 16px;
                    font-family: Microsoft YaHei, Microsoft YaHei-400;
                    font-weight: 400;
                    color: #ffffff;
                }
            }
        }
    }



    .address-page {
        width: 100%;
        // height: 640px;
        background: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        .address-view {
            // display: flex;
            // justify-content: space-between;
            // align-items: center;
            width: 90%;

            // height: 100%;
            .address-img1 {
                width: 100%;
                height: auto;
            }

            .line {
                margin-top: 32px;
                width: 82%;
                height: 1px;
                background: #e8e8e8;
                color: #222222;
            }

            .address-img {
                // width: 50%;
                // height: 440px;F

                .title {
                    margin-top: 48px;
                    font-size: 28px;
                    font-family: Microsoft YaHei, Microsoft YaHei-700;
                    font-weight: 700;
                    color: #222222;
                    display: flex;
                    align-items: center;
                }

                .phone {
                    margin-top: 32px;
                    font-size: 14px;
                    font-family: Microsoft YaHei, Microsoft YaHei-400;
                    font-weight: 400;
                    color: #999999;
                }

                .phone-num {
                    margin-top: 12px;
                    font-size: 28px;
                    font-family: Montserrat, Montserrat-600;
                    font-weight: 600;
                    color: #222222;
                }

                .line {
                    margin-top: 32px;
                    width: 82%;
                    height: 1px;
                    background: #e8e8e8;
                    color: #222222;
                }
            }
        }
    }
}
</style>
